import { GetApiData } from "utils/http-client";

/**
 * Server-side form drafts — replaces the previous localStorage autosave drafts.
 * A draft is keyed by a stable string per form (e.g.
 * "assignment-draft-exercise-<id>", "exercise-prompt-draft-listening",
 * "submission-review-draft-<id>").
 */

/** List the user's drafts, optionally filtered by key prefix (newest first). */
export const listFormDrafts = async (prefix = "") =>
  GetApiData(
    `/form-draft${prefix ? `?prefix=${encodeURIComponent(prefix)}` : ""}`,
    "GET",
    null,
    true
  );

/** Fetch the current user's draft data for a key (returns {} if none). */
export const getFormDraft = async (key) =>
  GetApiData(`/form-draft/${encodeURIComponent(key)}`, "GET", null, true);

/** Merge only the changed fields into the draft (partial upsert). */
export const patchFormDraft = async (key, changed) =>
  GetApiData(`/form-draft/${encodeURIComponent(key)}`, "PATCH", { data: changed }, true);

/** Delete the draft once the work is committed. */
export const deleteFormDraft = async (key) =>
  GetApiData(`/form-draft/${encodeURIComponent(key)}`, "DELETE", null, true);
